if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      this.initNavigation();
    }

    getMediaItems() {
      return Array.from(this.querySelectorAll('[data-media-id]'));
    }

    getCurrentIndex() {
      return this.getMediaItems().findIndex(el => el.classList.contains('active'));
    }

    goTo(index) {
      const items = this.getMediaItems();
      if (index < 0 || index >= items.length) return;
      items.forEach(el => el.classList.remove('active'));
      items[index].classList.add('active');
      items[index].scrollIntoView();
      this.updateNavUI(index, items.length);
    }

    updateNavUI(index, total) {
      const prev = this.querySelector('.modal-nav-prev');
      const next = this.querySelector('.modal-nav-next');
      const counter = this.querySelector('.modal-nav-counter');
      if (prev) prev.style.opacity = index === 0 ? '0.25' : '1';
      if (next) next.style.opacity = index === total - 1 ? '0.25' : '1';
      if (counter) counter.textContent = (index + 1) + ' / ' + total;
    }

    initNavigation() {
      const items = this.getMediaItems();
      if (items.length <= 1) return;
      if (this.querySelector('.modal-nav-prev')) {
        this.updateNavUI(this.getCurrentIndex(), items.length);
        return;
      }

      if (!document.getElementById('modal-nav-styles')) {
        const style = document.createElement('style');
        style.id = 'modal-nav-styles';
        style.textContent = [
          '.modal-nav-btn {',
          '  position: absolute;',
          '  top: 50%;',
          '  transform: translateY(-50%);',
          '  background: rgba(0,0,0,0.55);',
          '  color: #fff;',
          '  border: none;',
          '  border-radius: 50%;',
          '  width: 48px;',
          '  height: 48px;',
          '  font-size: 26px;',
          '  line-height: 1;',
          '  cursor: pointer;',
          '  z-index: 100;',
          '  display: flex;',
          '  align-items: center;',
          '  justify-content: center;',
          '  transition: opacity 0.2s, background 0.2s;',
          '}',
          '.modal-nav-btn:hover { background: rgba(0,0,0,0.8); }',
          '.modal-nav-prev { left: 14px; }',
          '.modal-nav-next { right: 14px; }',
          '.modal-nav-counter {',
          '  position: absolute;',
          '  bottom: 18px;',
          '  left: 50%;',
          '  transform: translateX(-50%);',
          '  background: rgba(0,0,0,0.5);',
          '  color: #fff;',
          '  padding: 4px 14px;',
          '  border-radius: 20px;',
          '  font-size: 13px;',
          '  letter-spacing: 0.05em;',
          '  z-index: 100;',
          '}'
        ].join('\n');
        document.head.appendChild(style);
      }

      const dialog = this.querySelector('.product-media-modal__dialog');
      dialog.style.position = 'relative';

      const prev = document.createElement('button');
      prev.className = 'modal-nav-btn modal-nav-prev';
      prev.innerHTML = '&#8249;';
      prev.setAttribute('aria-label', 'Image précédente');
      prev.addEventListener('click', (e) => {
        e.stopPropagation();
        const idx = this.getCurrentIndex();
        if (idx > 0) this.goTo(idx - 1);
      });

      const next = document.createElement('button');
      next.className = 'modal-nav-btn modal-nav-next';
      next.innerHTML = '&#8250;';
      next.setAttribute('aria-label', 'Image suivante');
      next.addEventListener('click', (e) => {
        e.stopPropagation();
        const idx = this.getCurrentIndex();
        if (idx < items.length - 1) this.goTo(idx + 1);
      });

      const counter = document.createElement('div');
      counter.className = 'modal-nav-counter';

      dialog.appendChild(prev);
      dialog.appendChild(next);
      dialog.appendChild(counter);

      // Swipe mobile
      let touchStartX = 0;
      const content = this.querySelector('[role="document"]');
      content.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      content.addEventListener('touchend', (e) => {
        const diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) < 50) return;
        const idx = this.getCurrentIndex();
        if (diff > 0 && idx < items.length - 1) this.goTo(idx + 1);
        else if (diff < 0 && idx > 0) this.goTo(idx - 1);
      }, { passive: true });

      // Clavier
      this.addEventListener('keydown', (e) => {
        const idx = this.getCurrentIndex();
        if (e.key === 'ArrowLeft' && idx > 0) this.goTo(idx - 1);
        if (e.key === 'ArrowRight' && idx < items.length - 1) this.goTo(idx + 1);
      });

      this.updateNavUI(this.getCurrentIndex(), items.length);
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      if (!activeMedia) return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
